"use client";

import { subscriptionDetailSchema } from "../../../lib/types/schema/subscription/subscriptionSchema";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keySubscriptions } from "./keySubscriptions";

export const useRequestSubscriptions = () => {
  return {
    query: useRequestQuery({
      queryFnRequestProps: {
        schema: subscriptionDetailSchema.array(),
        urlBackendPath: "/subscriptions",
      },
      queryKey: keySubscriptions(),
    }),
  };
};
